import { useState } from "preact/compat"
import { useLocation } from "wouter-preact"
import { CenterColumnContainer } from "@/components/LoginScreen.tsx"
import { Button } from "@/components/ui/button.tsx"
import { safeExec } from "@/utils"
import { getOauthUrl } from "@/api/integration"

export function ConnectGoogleDrivePage() {
  const [, setLocation] = useLocation()
  const [loading, setLoading] = useState(false)
  const currentPath = window.location.pathname

  function handleConnect() {
    safeExec(async () => {
      setLoading(true)
      const res = await getOauthUrl("googledrive", currentPath)
      setLoading(false)
      if (!res.ok) {
        console.error(res.error)
        return
      }
      window.location.href = res.value.data
    })
  }

  return (
    <CenterColumnContainer>
      <div class="space-y-6">
        <div class="text-center">
          <div class="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-4">
            <svg
              class="w-8 h-8 text-blue-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
              />
            </svg>
          </div>
          <h1 class="text-2xl font-bold text-gray-900">Connect Google Drive</h1>
          <p class="text-gray-500 text-sm mt-2">
            Connect your Google Drive account to sync files from shared folders. This allows you to automatically
            match backup files and BOL/POD documents to your deductions.
          </p>
        </div>

        <div class="space-y-4">
          <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <h3 class="font-medium text-blue-900 text-sm mb-2">What this enables:</h3>
            <ul class="text-sm text-blue-800 space-y-1 list-disc list-inside">
              <li>Sync backup files from shared Google Drive folders</li>
              <li>Automatically match files to deductions by invoice number</li>
              <li>Upload BOL/POD documents by PO number</li>
            </ul>
          </div>

          <Button
            onClick={handleConnect}
            disabled={loading}
            class="w-full bg-blue-600 hover:bg-blue-700 text-white">
            {loading ? "Connecting..." : "Connect Google Drive"}
          </Button>

          <p class="text-xs text-gray-400 text-center">
            You'll be redirected to Google to authorize access. We only request read-only access to your Drive.
          </p>
        </div>
      </div>
    </CenterColumnContainer>
  )
}
